import { platformFetch } from "services/platformFetch";
import { auth } from "services/firebase";
const { isPsoCode } = require("shared/bookIdentifiers");
const bookHeaders = async () => {
  if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await auth.currentUser.getIdToken()}`,
  };
};
export const reserveBookIdentifier = async (requestId) => {
  const response = await platformFetch("/api/book-identifiers", {
    method: "POST",
    headers: await bookHeaders(),
    body: JSON.stringify({ requestId }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível gerar o código PSO.");
  if (!isPsoCode(body.internalCode))
    throw new Error("Atualize o backend para habilitar a geração do código PSO.");
  return body;
};

export const createBookUploadUrls = async ({
  userId,
  title,
  isbn,
  internalCode,
  coverImageType,
}) => {
  let response;

  try {
    response = await platformFetch("/api/books/upload-urls", {
      method: "POST",
      headers: await bookHeaders(),
      body: JSON.stringify({ userId, title, isbn, internalCode, coverImageType }),
    });
  } catch (error) {
    throw new Error(
      "Nao foi possivel conectar ao servidor para preparar os uploads. Verifique sua conexao e tente novamente."
    );
  }
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    if ([502, 503, 504].includes(response.status)) {
      throw new Error(
        `O servidor de publicacao esta temporariamente indisponivel (HTTP ${response.status}). Tente novamente mais tarde. Se o erro persistir, contate o suporte.`
      );
    }

    throw new Error(
      body?.message || `Nao foi possivel preparar os uploads do livro (HTTP ${response.status}).`
    );
  }

  if (
    !["coverPdf", "interiorPdf", "coverImage"].every(
      (name) => body?.files?.[name]?.uploadUrl && body?.files?.[name]?.publicUrl
    )
  ) {
    throw new Error("O servidor retornou links de upload invalidos. Tente novamente mais tarde.");
  }

  return body;
};

export const uploadBookFile = async ({ uploadUrl, file, contentType, label }) => {
  let response;

  try {
    response = await platformFetch(uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Type": contentType,
      },
      body: file,
    });
  } catch (error) {
    const fileLabel = label || file?.name || "arquivo";
    throw new Error(
      `Falha ao enviar ${fileLabel} para o S3. Verifique o CORS do bucket para este dominio. Detalhes: ${error.message}`
    );
  }

  if (!response.ok) {
    const fileLabel = label || file?.name || "arquivo";
    throw new Error(`Nao foi possivel enviar ${fileLabel} para o S3. HTTP ${response.status}.`);
  }
};

export const getMyBooks = async ({ authId }) => {
  const params = new URLSearchParams({ authId });
  const response = await platformFetch(`/api/books?${params.toString()}`, { headers: await bookHeaders() });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    const details = body?.details ? ` Detalhes: ${JSON.stringify(body.details)}` : "";
    throw new Error(`${body?.message || "Nao foi possivel consultar suas publicacoes."}${details}`);
  }

  return body;
};

export const createBookProduct = async (book) => {
  const response = await platformFetch("/api/books", {
    method: "POST",
    headers: await bookHeaders(),
    body: JSON.stringify(book),
  });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    const details = body?.details ? ` Detalhes: ${JSON.stringify(body.details)}` : "";
    throw new Error(`${body?.message || "Nao foi possivel cadastrar o livro na Tray."}${details}`);
  }

  return body;
};

export const getBookForEditing = async (id) => {
  const response = await platformFetch(`/api/books/${encodeURIComponent(id)}`, {
    headers: await bookHeaders(),
    cache: "no-store",
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível abrir a publicação.");
  return body;
};

export const updateBook = async (id, fields) => {
  const response = await platformFetch(`/api/books/${encodeURIComponent(id)}`, {
    method: "PUT",
    headers: await bookHeaders(),
    body: JSON.stringify(fields),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível salvar a publicação.");
  return body;
};
